// https://vuex.vuejs.org/en/state.html

export default {
  googleShoppingInfo: {
    searchedProducts: [],
    selectedProduct: {
      text: '',
      id: null,
    },
    productLoading: false,
    productList: [],
    loadingProductList: false,
    status: {
      loggedIn: false,
      credentialsValid: false,
      syncRunning: false,
      merchants: [],
    },
    selectedMerchantId: null,
  },
  bazaarvoiceStatus: {
    loggedIn: false,
    credentialsValid: false,
    syncRunning: false,
    numSubmitted: 0,
    numEligibleAuto: 0,
    numEligibleManual: 0,
  },
  integrationProducts: {
    items: [],
    numUnlinked: 0,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: ['name'],
      recordsFiltered: 0,
      rowsPerPageItems: [10, 20, 30],
      filterBy: 'linked',
    },
  },
};
